// French translations
const fr = {
  // Navigation
  nav: {
    prayerRequest: "Demande de Prière",
    sacredSites: "Lieux Sacrés",
    prayerWall: "Mur de Prières",
    testimonials: "Témoignages",
    holyWord: "Parole Sainte",
    pricing: "Tarifs",
    login: "Connexion",
    signup: "S'inscrire",
    dashboard: "Tableau de Bord",
    admin: "Admin",
    logout: "Déconnexion"
  },
  
  // Home page
  home: {
    badge: "Connecter les Cœurs à la Terre Sainte",
    title: "Connectez Votre Cœur à la",
    titleHighlight: "Terre Sacrée",
    subtitle: "Vos prières les plus profondes méritent un voyage sacré. Nous livrons personnellement vos intentions aux lieux les plus saints de Jérusalem, les offrant avec révérence, et vous envoyant une photographie commémorative.",
    cta: "Commencez Votre Voyage de Prière",
    discoverSites: "Découvrir les Lieux Sacrés",
    prayerFor: "Prière pour",
    family: "Famille",
    health: "Santé",
    peace: "Paix",
    howItWorks: "Comment Ça Marche",
    howItWorksSubtitle: "Un voyage sacré en trois étapes simples",
    step1Title: "Écrivez Votre Prière",
    step1Desc: "Partagez ce qui est dans votre cœur. Votre prière est gardée complètement confidentielle et traitée avec révérence.",
    step2Title: "Choisissez les Lieux Sacrés",
    step2Desc: "Sélectionnez parmi les lieux les plus vénérés de Jérusalem où votre prière sera livrée personnellement.",
    step3Title: "Recevez la Confirmation",
    step3Desc: "Recevez une photographie confirmant la livraison de votre prière en Terre Sainte.",
    sacredSites: "Lieux Sacrés",
    sacredSitesSubtitle: "Où vos prières trouvent leur foyer",
    viewAllSites: "Voir Tous les Lieux Sacrés",
    testimonials: "Témoignages",
    testimonialsSubtitle: "Histoires de foi et de prières exaucées",
    readMore: "Lire Plus de Témoignages",
    startJourney: "Commencez Votre Voyage de Prière Aujourd'hui",
    startJourneySubtitle: "Rejoignez des milliers de personnes qui ont trouvé la paix grâce à notre service sacré de livraison de prières",
    submitPrayer: "Soumettre Votre Prière"
  },
  
  // Prayer Request page
  prayerRequest: {
    title: "Envoyez Votre Prière aux Lieux Saints de Jérusalem",
    subtitle: "Un voyage sacré en trois étapes simples",
    step: "Étape",
    type: "Type",
    sites: "Lieux",
    prayer: "Prière",
    details: "Détails",
    chooseType: "Choisissez Votre Type de Prière",
    oneTime: "Prière Unique",
    oneTimeDesc: "Choisissez vos lieux sacrés et envoyez une seule prière",
    journey: "Voyage de Prière",
    journeyDesc: "Un voyage de prière continu dans vos lieux sacrés choisis",
    choosePackage: "Choisissez Votre Forfait de Prière",
    holySite: "Lieu Saint",
    holySites: "Lieux Saints",
    mostPopular: "PLUS POPULAIRE",
    chooseSites: "Choisissez Vos Lieux Sacrés",
    chooseSitesDesc: "Sélectionnez un ou plusieurs lieux saints où votre prière sera livrée",
    selectAll: "Tout Sélectionner",
    clear: "Effacer",
    writePrayer: "Écrivez Votre Prière",
    writePrayerDesc: "Partagez votre prière sincère. Elle sera gardée privée et traitée avec révérence.",
    prayerPlaceholder: "Écrivez votre prière ici...",
    characters: "caractères",
    minRequired: "Minimum 50 requis",
    prayerLibrary: "Bibliothèque de Prières",
    yourDetails: "Vos Coordonnées",
    yourDetailsDesc: "Nous enverrons la confirmation de votre prière à cet email",
    dedicatedTo: "Cette Prière Est Dédiée à",
    dedicatedPlaceholder: "Entrez le(s) nom(s)",
    yourName: "Votre Nom",
    namePlaceholder: "Entrez votre nom",
    yourEmail: "Votre Email",
    emailPlaceholder: "Entrez votre email",
    reviewRequest: "Vérifiez Votre Demande de Prière",
    prayerType: "Type de Prière",
    sacredSites: "Lieux Sacrés",
    selected: "sélectionnés",
    prayerLength: "Longueur de la Prière",
    back: "Retour",
    previous: "Précédent",
    next: "Suivant",
    continue: "Continuer",
    submit: "Soumettre",
    submitPrayer: "Soumettre la Prière",
    submitting: "Envoi en cours..."
  },
  
  // Checkout
  checkout: {
    backToPricing: "Retour aux Tarifs",
    orderSummary: "Résumé de la Commande",
    billedMonthly: "Facturé mensuellement",
    billedAnnually: "Facturé annuellement",
    total: "Total",
    chargedMonthly: "Facturé mensuellement jusqu'à annulation",
    chargedAnnually: "Facturé annuellement jusqu'à annulation",
    secureCheckout: "Paiement Sécurisé",
    securePayment: "Votre paiement est traité de manière sécurisée par Stripe. Nous ne stockons jamais vos données de carte.",
    features: {
      photos: "Photos de haute qualité",
      delivery: "Livraison personnelle aux lieux saints",
      confirmation: "Confirmation par email avec coordonnées GPS",
      cancel: "Annulez à tout moment, sans frais"
    },
    contactInfo: "Coordonnées",
    emailAddress: "Adresse Email",
    emailPlaceholder: "vous@exemple.com",
    emailHelper: "Nous enverrons votre confirmation et reçu ici",
    stripeRedirect: "Après avoir cliqué sur le bouton ci-dessous, vous serez redirigé vers la page de paiement sécurisé de Stripe pour finaliser votre achat.",
    agreeTerms: "J'accepte les",
    termsOfService: "Conditions d'Utilisation",
    and: "et",
    privacyPolicy: "Politique de Confidentialité",
    subscriptionNote: "Je comprends qu'il s'agit d'un abonnement récurrent qui sera automatiquement renouvelé jusqu'à annulation.",
    pay: "Payer",
    continueToPay: "Continuer vers le Paiement",
    processing: "Traitement...",
    redirecting: "Redirection vers le paiement...",
    secureStripe: "Votre paiement est sécurisé par Stripe avec cryptage SSL 256 bits",
    moneyBack: "Garantie Remboursement 7 Jours",
    moneyBackDesc: "Si vous n'êtes pas entièrement satisfait de notre service de livraison de prières dans les 7 jours, nous vous rembourserons intégralement, sans questions. Votre paix spirituelle est notre priorité."
  },
  
  // Footer
  footer: {
    stayConnected: "Restez Connecté avec Jérusalem",
    newsletterDesc: "Recevez des réflexions spirituelles et des mises à jour des lieux sacrés",
    emailPlaceholder: "Entrez votre email",
    subscribe: "S'abonner",
    subscribed: "Merci de vous être abonné!",
    quickLinks: "Liens Rapides",
    resources: "Ressources",
    connectWithUs: "Connectez-vous avec Nous",
    followUs: "Suivez-nous pour des bénédictions quotidiennes et de l'inspiration de la Terre Sainte.",
    copyright: "© 2025 Jerusalem Holy Prayer. Tous droits réservés.",
    privacy: "Politique de Confidentialité",
    terms: "Conditions d'Utilisation"
  },
  
  // Auth
  auth: {
    welcomeBack: "Bon Retour",
    signIn: "Connectez-vous à votre compte",
    email: "Email",
    password: "Mot de Passe",
    forgotPassword: "Mot de passe oublié?",
    login: "Se Connecter",
    loggingIn: "Connexion...",
    noAccount: "Pas de compte?",
    signUp: "S'inscrire",
    createAccount: "Créer un Compte",
    joinUs: "Rejoignez notre communauté de croyants",
    name: "Nom Complet",
    confirmPassword: "Confirmer le Mot de Passe",
    creating: "Création du compte...",
    hasAccount: "Déjà un compte?",
    passwordRequirement: "Au moins 6 caractères"
  },
  
  // Common
  common: {
    loading: "Chargement...",
    error: "Erreur",
    success: "Succès",
    save: "Enregistrer",
    cancel: "Annuler",
    delete: "Supprimer",
    edit: "Modifier",
    view: "Voir",
    close: "Fermer",
    search: "Rechercher",
    filter: "Filtrer",
    all: "Tout",
    learnMore: "En Savoir Plus"
  },

  // Pricing page
  pricing: {
    title: "Tarification Simple et Transparente",
    subtitle: "Choisissez le voyage sacré qui résonne avec votre cœur",
    oneTime: "Prière Unique",
    oneTimeDesc: "Parfait pour les intentions et occasions spéciales",
    subscription: "Voyage de Prière",
    subscriptionDesc: "Connexion spirituelle continue avec la Terre Sainte",
    holySite: "Lieu Saint",
    holySites: "Lieux Saints",
    popular: "PLUS POPULAIRE",
    perMonth: "/mois",
    perYear: "/an",
    billedAnnually: "facturé annuellement",
    monthly: "Mensuel",
    annual: "Annuel",
    savePercent: "Économisez 17%",
    selectPlan: "Sélectionner",
    getStarted: "Commencer",
    features: "Fonctionnalités",
    includes: "Inclut",
    chooseThis: "Choisir Ce Plan"
  },

  // Sacred Sites page
  sacredSites: {
    title: "Lieux Sacrés de Jérusalem",
    subtitle: "Découvrez les lieux saints où vos prières seront livrées",
    exploreAll: "Explorer Tous les Sites",
    viewDetails: "Voir les Détails"
  },

  // Prayer Wall page
  prayerWall: {
    title: "Mur de Prières",
    subtitle: "Rejoignez notre communauté en prière. Lisez et inspirez-vous des prières des autres croyants.",
    recentPrayers: "Prières Récentes",
    anonymous: "Anonyme",
    prayedAt: "A prié à"
  },

  // Testimonials page
  testimonials: {
    title: "Histoires de Foi",
    subtitle: "Découvrez comment Jerusalem Holy Prayer a touché des vies à travers le monde",
    readMore: "Lire Plus",
    verifiedPurchase: "Achat Vérifié"
  },

  // Contact page
  contact: {
    title: "Contactez-Nous",
    subtitle: "Nous serions ravis de vous entendre. Envoyez-nous un message et nous vous répondrons dès que possible.",
    name: "Votre Nom",
    email: "Votre Email",
    subject: "Sujet",
    message: "Message",
    send: "Envoyer le Message",
    sending: "Envoi en cours...",
    address: "Adresse",
    phone: "Téléphone",
    emailUs: "Écrivez-Nous",
    successTitle: "Message Envoyé",
    successDesc: "Nous vous répondrons bientôt."
  },

  // FAQ page
  faq: {
    title: "Questions Fréquentes",
    subtitle: "Trouvez des réponses aux questions courantes sur notre service de livraison de prières"
  },

  // About page
  about: {
    title: "À Propos de Nous",
    subtitle: "Notre mission est de connecter les cœurs avec la Terre Sainte",
    ourStory: "Notre Histoire",
    ourTeam: "Notre Équipe à Jérusalem"
  },

  // Dashboard
  dashboard: {
    title: "Mon Tableau de Bord",
    welcome: "Bon retour",
    myPrayers: "Mes Prières",
    myPayments: "Mes Paiements",
    noPrayers: "Pas encore de prières",
    noPayments: "Pas encore de paiements",
    viewAll: "Voir Tout",
    status: "Statut",
    date: "Date",
    amount: "Montant"
  },

  // Checkout Success
  checkoutSuccess: {
    title: "Paiement Réussi!",
    subtitle: "Merci pour votre commande. Votre voyage de prière commence maintenant.",
    orderNumber: "Numéro de Commande",
    emailSent: "Un email de confirmation a été envoyé à",
    whatNext: "Et maintenant?",
    step1: "Notre équipe reçoit votre demande de prière",
    step2: "Nous livrons personnellement votre prière aux lieux sacrés",
    step3: "Vous recevez des photos et une confirmation par email",
    returnHome: "Retour à l'Accueil",
    viewDashboard: "Voir le Tableau de Bord"
  },

  // About page extended
  aboutPage: {
    ourStory: "Notre Histoire",
    ourStoryP1: "Jerusalem Holy Prayer est né d'une simple conversation en 2019 entre trois amis assis dans un café près de la Porte de Jaffa. Rachel, une guide touristique qui avait passé quinze ans à guider des pèlerins chrétiens à travers la Terre Sainte, a partagé son chagrin pour les innombrables personnes qu'elle a rencontrées qui rêvaient de visiter Jérusalem mais ne pouvaient pas—en raison de problèmes de santé, de contraintes financières, d'obligations familiales ou de l'âge.",
    ourStoryP2: "\"Tant de gens pleurent quand ils me disent qu'ils ne verront jamais ces endroits en personne\", a-t-elle dit. \"Et si nous pouvions apporter leurs prières ici?\" Cette question a déclenché tout ce qui a suivi.",
    ourStoryP3: "Les trois fondateurs—Rachel, David (un théologien chrétien et résident de longue date de Jérusalem), et Sarah (une photographe documentant les lieux saints)—ont commencé petit. Ils ont proposé de livrer des prières pour des amis et des membres de la famille à l'étranger. Le bouche-à-oreille s'est répandu à travers les églises, les groupes de prière et les communautés de foi. Ce qui a commencé comme une poignée de prières manuscrites portées au Mur Occidental est devenu une mission servant des milliers de croyants dans le monde entier.",
    ourStoryP4: "Aujourd'hui, notre équipe s'est agrandie pour inclure douze personnes dévouées, toutes résidentes de Jérusalem avec des liens profonds avec la géographie sacrée de la ville. Certains sont des Israéliens natifs, d'autres ont fait l'aliya depuis divers pays, apportant diverses traditions chrétiennes—catholique, orthodoxe, protestante et plus. Ce qui nous unit est une profonde révérence pour la signification spirituelle de Jérusalem et un engagement à servir ceux qui cherchent à se connecter avec ces lieux saints.",
    ourStoryP5: "Nous naviguons quotidiennement sur les pierres anciennes de la Vieille Ville, maintenant des relations avec les gardiens et les conservateurs des sites qui comprennent notre mission. Nous avons appris les rythmes de chaque lieu—quand l'Église du Saint-Sépulcre est la plus calme pour la contemplation, quels jours offrent le meilleur accès au Tombeau du Jardin, comment planifier les livraisons pour éviter de perturber les services de culte et les groupes de pèlerins.",
    ourStoryP6: "Depuis notre fondation, nous avons livré plus de 50 000 prières aux lieux sacrés de Jérusalem. Chacune représente les espoirs les plus profonds, les peurs, la gratitude ou les pétitions d'une personne. Nous avons porté des prières de guérison pendant des maladies, de guidance pendant des transitions de vie, de réconciliation dans des relations brisées, de force pendant le deuil, et d'action de grâce pendant la joie. Le privilège de ce travail nous humilie quotidiennement.",
    ourStoryP7: "Nous croyons que la foi transcende la géographie, mais il y a quelque chose de puissant dans la présence physique dans des lieux sanctifiés par des siècles de prière et de dévotion. À travers notre service, nous aidons à combler la distance entre les cœurs qui aspirent à la connexion et les pierres anciennes qui ont été témoins du voyage spirituel de l'humanité pendant des millénaires.",
    ourValues: "Nos Valeurs Fondamentales",
    valueReverence: "Révérence",
    valueReverenceDesc: "Chaque prière est traitée avec le plus profond respect et soin spirituel",
    valueCommunity: "Communauté",
    valueCommunityDesc: "Connecter les croyants du monde entier par la foi et la prière partagées",
    valueAccessibility: "Accessibilité",
    valueAccessibilityDesc: "Rendre la Terre Sainte accessible à tous, partout",
    valueAuthenticity: "Authenticité",
    valueAuthenticityDesc: "Expériences spirituelles authentiques enracinées dans d'anciennes traditions sacrées",
    ourTeamTitle: "Notre Équipe à Jérusalem",
    ourTeamP1: "Notre équipe se compose de douze personnes qui appellent Jérusalem leur maison—pas des touristes ou des résidents temporaires, mais des personnes profondément enracinées dans cette ville ancienne. La plupart vivent ici depuis dix ans ou plus; certains sont nés dans les murs de la Vieille Ville. Ce n'est pas seulement notre lieu de travail; c'est là où nous adorons, élevons nos familles et vivons la vie quotidienne au milieu des sites qui ont façonné le paysage spirituel de la civilisation occidentale.",
    ourTeamP2: "Chaque membre de l'équipe apporte des forces uniques. Rachel et David, nos cofondateurs, supervisent les opérations et maintiennent des relations avec les conservateurs des sites. Sarah dirige notre équipe de documentation, assurant que chaque photographie capture authentiquement le moment de la livraison de la prière.",
    ourTeamP3: "D'autres gèrent la logistique—Miriam coordonne les horaires selon l'accès aux sites et les observances religieuses; Benjamin gère nos communications multilingues; Leah et Thomas livrent des prières aux sites dans toute la ville. Tous reçoivent une formation sur les protocoles respectueux des sites, la documentation photographique et la manipulation des prières avec la révérence qu'elles méritent.",
    ourTeamP4: "Nous ne sommes pas une grande organisation, et nous préférons cela ainsi. Cela nous permet de maintenir une touche personnelle et un soin sincère pour chaque prière que nous traitons. Beaucoup d'entre nous échangent des emails avec des utilisateurs réguliers, construisant des relations qui vont au-delà des transactions individuelles. Quand nous livrons une prière pour quelqu'un qui lutte contre une maladie ou célèbre une étape importante, nous portons son histoire avec nous vers les lieux saints.",
    ourTeamP5: "Vivre à Jérusalem signifie naviguer dans des réalités complexes—tensions politiques, préoccupations de sécurité et les défis quotidiens d'une ville divisée. Pourtant, nous sommes convaincus que ce travail compte. Dans un monde souvent marqué par la division, nous facilitons des connexions enracinées dans la foi, l'espoir et l'humanité partagée. Chaque prière que nous livrons est un acte de construction de ponts, un petit geste vers la paix que le nom de Jérusalem promet."
  },

  // FAQ page extended
  faqPage: {
    stillHaveQuestions: "Vous Avez Encore des Questions?",
    stillHaveQuestionsDesc: "Notre équipe est là pour vous aider. N'hésitez pas à nous contacter à tout moment.",
    contactUs: "Contactez-Nous"
  },

  // Terms page
  termsPage: {
    title: "Conditions d'Utilisation",
    lastUpdated: "Dernière Mise à Jour: Janvier 2025",
    agreementTitle: "Acceptation des Conditions",
    agreementText: "En accédant et en utilisant les services de Jerusalem Holy Prayer, vous acceptez d'être lié par ces Conditions d'Utilisation. Si vous n'êtes pas d'accord avec une partie de ces conditions, vous ne pouvez pas utiliser nos services.",
    servicesTitle: "Nos Services",
    servicesIntro: "Jerusalem Holy Prayer fournit un service de livraison de prières où:",
    servicesItem1: "Les utilisateurs soumettent des prières via notre site web",
    servicesItem2: "Notre équipe basée à Jérusalem livre ces prières aux lieux saints sélectionnés",
    servicesItem3: "Les utilisateurs reçoivent une confirmation photographique de livraison",
    servicesItem4: "Les options d'abonnement fournissent des services continus de livraison de prières",
    responsibilitiesTitle: "Responsabilités de l'Utilisateur",
    responsibilitiesIntro: "En utilisant notre service, vous acceptez de:",
    responsibilitiesItem1: "Fournir des informations exactes et complètes",
    responsibilitiesItem2: "Soumettre des prières respectueuses et appropriées",
    responsibilitiesItem3: "Ne pas utiliser le service à des fins illégales",
    responsibilitiesItem4: "Respecter la nature sacrée des sites où les prières sont livrées",
    responsibilitiesItem5: "Ne pas partager ou revendre l'accès à votre compte",
    contentTitle: "Directives de Contenu",
    contentIntro: "Toutes les soumissions de prières doivent être:",
    contentItem1: "Respectueuses et appropriées pour les environnements sacrés",
    contentItem2: "Exemptes de discours de haine, de violence ou de contenu discriminatoire",
    contentItem3: "Sans promotion d'activités illégales",
    contentItem4: "Des expressions spirituelles sincères",
    contentNote: "Nous nous réservons le droit de refuser le service pour les prières qui violent ces directives.",
    paymentTitle: "Paiement et Abonnements",
    paymentOneTime: "Prières Uniques: Le paiement est requis au moment de la soumission.",
    paymentSubscriptions: "Abonnements:",
    paymentItem1: "Facturés mensuellement ou annuellement selon la sélection",
    paymentItem2: "Renouvelés automatiquement sauf annulation",
    paymentItem3: "Peuvent être annulés à tout moment via votre compte",
    paymentItem4: "L'annulation prend effet à la fin de la période de facturation en cours",
    paymentItem5: "Pas de remboursements pour les mois partiels",
    refundTitle: "Politique de Remboursement",
    refundItem1: "Les remboursements peuvent être demandés dans les 7 jours suivant la livraison de la prière si le service n'a pas été fourni comme décrit",
    refundItem2: "Pas de remboursements après que la prière a été livrée et confirmée",
    refundItem3: "Les remboursements d'abonnement ne sont pas disponibles pour les portions non utilisées de la période d'abonnement",
    refundItem4: "Toutes les demandes de remboursement doivent être soumises par écrit à notre équipe de support",
    availabilityTitle: "Disponibilité du Service",
    availabilityIntro: "Bien que nous nous efforcions de livrer toutes les prières dans les délais promis, nous ne pouvons pas garantir la disponibilité du service pendant:",
    availabilityItem1: "Les fêtes religieuses majeures lorsque les sites peuvent être fermés ou restreints",
    availabilityItem2: "Les situations de sécurité à Jérusalem",
    availabilityItem3: "Les catastrophes naturelles ou les urgences",
    availabilityItem4: "Les problèmes techniques hors de notre contrôle",
    availabilityNote: "Dans de tels cas, nous vous informerons et reprogrammerons ou offrirons un remboursement.",
    intellectualTitle: "Propriété Intellectuelle",
    intellectualText: "Tout le contenu de ce site web, y compris le texte, les graphiques, les logos et les photographies, est la propriété de Jerusalem Holy Prayer et est protégé par les lois sur les droits d'auteur. Vous ne pouvez pas reproduire, distribuer ou créer des œuvres dérivées sans notre permission écrite.",
    liabilityTitle: "Limitation de Responsabilité",
    liabilityText: "Jerusalem Holy Prayer fournit ce service comme une offrande spirituelle. Nous ne garantissons pas de résultats spécifiques de la prière. Notre responsabilité est limitée au montant payé pour le service. Nous ne sommes pas responsables des dommages indirects, accessoires ou consécutifs.",
    modificationsTitle: "Modifications du Service",
    modificationsText: "Nous nous réservons le droit de modifier, suspendre ou interrompre toute partie de notre service à tout moment. Nous fournirons un avis des changements importants lorsque possible.",
    governingTitle: "Loi Applicable",
    governingText: "Ces Conditions d'Utilisation sont régies par les lois de l'État d'Israël. Tout litige sera résolu devant les tribunaux de Jérusalem.",
    contactTitle: "Informations de Contact",
    contactText: "Pour des questions sur ces Conditions d'Utilisation, veuillez nous contacter à:"
  },

  // Privacy page
  privacyPage: {
    title: "Politique de Confidentialité",
    lastUpdated: "Dernière Mise à Jour: Janvier 2025",
    introTitle: "Introduction",
    introText: "Chez Jerusalem Holy Prayer, nous prenons votre vie privée au sérieux. Cette Politique de Confidentialité explique comment nous collectons, utilisons et protégeons vos informations personnelles lorsque vous utilisez notre service de livraison de prières.",
    collectTitle: "Informations que Nous Collectons",
    personalInfo: "Informations Personnelles:",
    personalItem1: "Nom et coordonnées (adresse email)",
    personalItem2: "Texte de prière et informations de dédicace",
    personalItem3: "Informations de paiement (traitées de manière sécurisée via des fournisseurs tiers)",
    personalItem4: "Correspondance avec notre équipe de support",
    autoInfo: "Informations Collectées Automatiquement:",
    autoItem1: "Type de navigateur et informations sur l'appareil",
    autoItem2: "Adresse IP et données de localisation",
    autoItem3: "Statistiques d'utilisation du site web",
    useTitle: "Comment Nous Utilisons Vos Informations",
    useItem1: "Pour livrer vos prières aux lieux sacrés sélectionnés",
    useItem2: "Pour vous envoyer des emails de confirmation et des photos de livraison",
    useItem3: "Pour traiter les paiements de manière sécurisée",
    useItem4: "Pour améliorer nos services et l'expérience utilisateur",
    useItem5: "Pour communiquer avec vous concernant vos demandes",
    useItem6: "Pour envoyer des newsletters (uniquement avec votre consentement)",
    confidentialityTitle: "Confidentialité des Prières",
    confidentialityText: "Vos prières sont traitées avec la plus grande révérence et confidentialité. Elles ne sont manipulées que par les membres de notre équipe de confiance basée à Jérusalem et ne sont jamais partagées, vendues ou utilisées à d'autres fins que la livraison aux lieux saints que vous avez sélectionnés.",
    securityTitle: "Sécurité des Données",
    securityText: "Nous mettons en œuvre des mesures de sécurité standard de l'industrie pour protéger vos informations personnelles. Cela inclut le cryptage, les serveurs sécurisés et l'accès restreint aux données sensibles. Cependant, aucune méthode de transmission sur Internet n'est 100% sécurisée, et nous ne pouvons pas garantir une sécurité absolue.",
    thirdPartyTitle: "Services Tiers",
    thirdPartyIntro: "Nous utilisons des services tiers de confiance pour:",
    thirdPartyItem1: "Le traitement des paiements (vos informations de paiement sont gérées de manière sécurisée par notre fournisseur de paiement)",
    thirdPartyItem2: "Les services de livraison d'emails",
    thirdPartyItem3: "Les analyses du site web",
    thirdPartyNote: "Ces services ont leurs propres politiques de confidentialité, et nous vous encourageons à les consulter.",
    rightsTitle: "Vos Droits",
    rightsIntro: "Vous avez le droit de:",
    rightsItem1: "Accéder à vos informations personnelles",
    rightsItem2: "Demander la correction de données inexactes",
    rightsItem3: "Demander la suppression de vos informations",
    rightsItem4: "Vous désabonner des communications marketing",
    rightsItem5: "Retirer votre consentement au traitement des données",
    cookiesTitle: "Cookies",
    cookiesText: "Nous utilisons des cookies pour améliorer votre expérience de navigation et analyser le trafic du site web. Vous pouvez contrôler les paramètres des cookies via les préférences de votre navigateur.",
    changesTitle: "Modifications de Cette Politique",
    changesText: "Nous pouvons mettre à jour cette Politique de Confidentialité de temps en temps. Nous vous informerons de tout changement significatif en publiant la nouvelle politique sur cette page et en mettant à jour la date de \"Dernière Mise à Jour\".",
    contactTitle: "Contactez-Nous",
    contactText: "Si vous avez des questions sur cette Politique de Confidentialité ou nos pratiques en matière de données, veuillez nous contacter à:"
  },

  // Dashboard extended
  dashboardPage: {
    memberSince: "Membre depuis",
    totalPrayers: "Total des Prières",
    totalPayments: "Total des Paiements",
    newPrayerRequest: "Nouvelle Demande de Prière",
    myPrayers: "Mes Prières",
    paymentHistory: "Historique des Paiements",
    noPrayersYet: "Pas encore de prières",
    noPrayersDesc: "Commencez votre voyage spirituel en soumettant votre première prière",
    submitFirstPrayer: "Soumettre Votre Première Prière",
    noPaymentsYet: "Pas encore de paiements",
    noPaymentsDesc: "Votre historique de paiements apparaîtra ici",
    viewPricingPlans: "Voir les Plans Tarifaires",
    oneTime: "Unique",
    journey: "Voyage",
    dedicatedTo: "Dédiée à:",
    holySitesSelected: "lieu(x) saint(s) sélectionné(s)"
  },

  // Admin Dashboard
  adminPage: {
    title: "Tableau de Bord Admin",
    subtitle: "Gérer les prières, les contacts et les utilisateurs",
    refresh: "Actualiser",
    totalUsers: "Total des Utilisateurs",
    prayerRequests: "Demandes de Prière",
    pending: "en attente",
    contactMessages: "Messages de Contact",
    new: "nouveaux",
    totalRevenue: "Revenus Totaux",
    payments: "paiements",
    tabs: {
      prayers: "Demandes de Prière",
      contacts: "Messages de Contact",
      users: "Utilisateurs",
      payments: "Paiements"
    },
    table: {
      status: "Statut",
      from: "De",
      dedicatedTo: "Dédiée À",
      sites: "Sites",
      date: "Date",
      actions: "Actions",
      customer: "Client",
      amount: "Montant",
      type: "Type",
      user: "Utilisateur",
      email: "Email",
      role: "Rôle",
      joined: "Inscrit"
    },
    actions: {
      process: "Traiter",
      deliver: "Livrer",
      markRead: "Marquer Lu",
      markResponded: "Marquer Répondu",
      makeAdmin: "Rendre Admin",
      removeAdmin: "Retirer Admin"
    },
    empty: {
      noPrayers: "Pas encore de demandes de prière",
      noContacts: "Pas encore de messages de contact",
      noUsers: "Pas encore d'utilisateurs",
      noPayments: "Pas encore de paiements"
    },
    roles: {
      admin: "Admin",
      user: "Utilisateur"
    }
  },

  // Contact page extended
  contactPage: {
    beforeReachOut: "Avant de Nous Contacter",
    forFasterAssistance: "Pour une assistance plus rapide, vérifiez si votre question est répondue dans notre:",
    faqLink: "Page FAQ",
    faqDesc: "- Couvre les questions les plus courantes sur notre service",
    aboutLink: "À Propos de Nous",
    aboutDesc: "- Découvrez notre équipe et notre mission",
    termsLink: "Conditions d'Utilisation",
    termsDesc: "- Politiques de remboursement, abonnements et détails du service",
    technicalNote: "Si vous rencontrez un problème technique avec le site web, veuillez inclure des détails sur votre navigateur, appareil et le message d'erreur spécifique que vous voyez.",
    callUs: "Appelez-Nous",
    jerusalemOffice: "Bureau de Jérusalem:",
    usSupportLine: "Ligne de Support US:",
    officeHours: "Jérusalem: Dim-Jeu 9h-17h (IST)",
    usHours: "Ligne US: Lun-Ven 9h-18h (EST)",
    officeLocation: "Emplacement du Bureau",
    officeAddress1: "Jerusalem Holy Prayer",
    officeAddress2: "Quartier Chrétien",
    officeAddress3: "Vieille Ville, Jérusalem 91140",
    officeNote: "Près de la Porte de Jaffa",
    officeVisit: "Visites sur rendez-vous uniquement",
    responseTimes: "Délais de Réponse",
    responseEmail: "Demandes par email: Dans les 24 heures (jours ouvrables)",
    responsePrayer: "Support prière: Même jour ou jour ouvrable suivant",
    responsePhone: "Appels téléphoniques: Immédiats pendant les heures de bureau",
    responseUrgent: "Demandes de prière urgentes: Réponse prioritaire dans les 4 heures",
    formIntro: "Que vous ayez des questions sur notre service, besoin d'aide pour une soumission de prière, ou que vous souhaitiez partager votre expérience, nous sommes là pour écouter. Notre équipe répond généralement dans les 24 heures pendant les jours ouvrables.",
    generalInquiries: "Demandes Générales:",
    prayerSupport: "Support Prière:",
    technicalSupport: "Support Technique:"
  },

  // Sacred Sites extended
  sacredSitesPage: {
    heroSubtitle: "Découvrez les lieux saints où vos prières seront livrées avec révérence et soin",
    allSites: "Tous les Sites",
    sendPrayerHere: "Envoyer une Prière Ici"
  },

  // Header mobile menu
  mobileMenu: {
    adminPanel: "Panneau Admin",
    signOut: "Déconnexion"
  }
};

export default fr;
